import { GpsCoords } from "@hornet-web-react/core/types/session"

export default function anonLatLng(
  input: string | GpsCoords,
  precision = 2
): string {
  if (typeof input !== "string") {
    if (GpsCoords.safeParse(input).success) {
      return `${input.lat.toFixed(precision)},${input.lng.toFixed(precision)}`
    }

    return ""
  }

  const [latStr, lngStr] = input.split(",")

  const lat = parseFloat(latStr)
  const lng = parseFloat(lngStr)

  if (isNaN(lat) || isNaN(lng)) {
    return ""
  }

  const roundedLat = lat.toFixed(precision)
  const roundedLng = lng.toFixed(precision)

  return `${roundedLat},${roundedLng}`
}
